import { News } from './news.model';

export class NewsAdapter extends News {
  constructor(data: Partial<NewsAdapter> = {}) {
    super(data);
  }
}
